import { EmbedContainer } from './Container';
import { SearchEmbed } from '@thoughtspot/visual-embed-sdk/react';
import { useVariable } from 'context/ThemeContext';
import { useEffect, useState } from 'react';
import { NoObjectSelected } from './NoObjectSelected';
import { SEARCH_EMBED_FEATURE_FLAGS } from '../../constants';

export const SearchEmbedBase = ({
  embedRef,
  variables,
  embedSelections,
  setEmbedSelections,
}: any) => {
  const dataSource = embedSelections?.dataSource;
  const searchType = embedSelections?.searchType || 'datasource';
  const answerId = searchType === 'answers' ? embedSelections?.answerId : '';
  const [searchData, setSearchData] = useState(null);
  const [answerData, setAnswerData] = useState(null);

  const {
    state: { dataSourceList, answerList },
  } = useVariable();

  useEffect(() => {
    const defaultDataSource = dataSourceList?.length > 0 ? dataSourceList[0]?.id : '';
    const defaultAnswer = answerList?.length > 0 ? answerList[0]?.id : '';
    if ((answerId || defaultAnswer) && setEmbedSelections && searchType === 'answers') {
      setAnswerData(answerId || answerList[0]?.id);
      setSearchData(null);
      setEmbedSelections({
        answerId: answerId || answerList[0]?.id,
        searchType: 'answers',
        dataSource: undefined,
      });
    } else if (defaultDataSource && setEmbedSelections && searchType === 'datasource') {
      setSearchData(dataSource || defaultDataSource);
      setAnswerData(null);
      setEmbedSelections({ dataSource: dataSource || defaultDataSource, searchType: 'datasource' });
    }
  }, [dataSource, dataSourceList, setEmbedSelections, answerId, searchType]);

  if (searchType === 'answers' && !answerData) {
    return (
      <NoObjectSelected title="No Answer Selected" description="Please select an answer to view" />
    );
  }

  return (
    <SearchEmbed
      frameParams={{
        height: '100%',
      }}
      ref={embedRef}
      className="embed-content"
      {...SEARCH_EMBED_FEATURE_FLAGS}
      dataSource={searchType === 'datasource' ? searchData : (undefined as any)}
      answerId={searchType === 'answers' ? answerData : (undefined as any)}
      customizations={{
        style: {
          customCSS: {
            variables: variables,
          },
        },
      }}
    />
  );
};
export const SearchEmbedPage = (props) => {
  return <EmbedContainer EmbedComponent={SearchEmbedBase} {...props} />;
};
